import { useTranslation } from 'react-i18next';

import { Text } from 'components/library';

import * as S from './styled';

import WellfunelLogo from 'assets/img/wellfunel.svg';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <S.FooterBox>
            <Text type="caption" color="text-secondary-subdued" medium mb={12}>
                {t('footer.madeWithLove')}
            </Text>
            <WellfunelLogo />
        </S.FooterBox>
    );
};

export { Footer };
